import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Link from '@visa/vds/link'
import Textfield from '@cybs-ui/components/lib/textfield';
import CybsFileUpload from '@cybs-ui/components/lib/file-upload';
import showDivBasedOnId, { hideDivBasedOnId } from '../../../commons/ui-commons';
import $ from 'jquery';
import { getIsWidget, getPartnerName } from '../../../lhs/reducers/configuration-reducer';

const handleFocus = (setDefault, setTextStyle) => {
    setDefault('');
    setTextStyle({border: "1px solid #b6b6b9", color: 'black'});
}

const resetTextField = (defaultString, setDefault, setTextStyle) => {
    setDefault(defaultString);
    setTextStyle({border: "1px solid #b6b6b9", color: 'grey'});
}

const JWTSet = (props) => {
    var partnerName = getPartnerName();
    const processor = useSelector(state => state.configurationReducer.processor);
    const retrieveFiles = file => {
        props.setP12(file);
         if(file[0]){
            if($(".css-4zuefr-fileSection-fileSection")[0] != undefined){
                $(".css-4zuefr-fileSection-fileSection")[0].textContent = file[0].name;
            }
            if($(".css-4zuefr-fileSection-fileSection")[1] != undefined){
                $(".css-4zuefr-fileSection-fileSection")[1].textContent = file[0].name;
            }
        }
    }
    const [merchantID_def, setMerchantIDDefault] = useState('Organization ID');
    const [jwtKey_def, setJWTKeyDefault] = useState('Enter your password for the P12 file')
    const [merchantID_textstyle, setMerchantIDTextStyle] = useState({border: "1px solid #b6b6b9", color: "grey"});
    const [jwtKey_textstyle, setJWTKeyTextStyle] = useState({color: "grey"});
    const activeTextField = {border: "1px solid #b6b6b9", color: 'black'};
    const activePassField = {color: 'black'};
    const [icon, setIcon] = useState('password-show');
    const [type, setType] = useState('password');
    useEffect(function switchState(){
        hideDivBasedOnId('updated-creds-jwt-api');
        hideDivBasedOnId('updated-creds-jwt-endpoint');
        showDivBasedOnId('default-creds-jwt-api');
        showDivBasedOnId('default-creds-jwt-endpoint');
            if( $("span[class$='fileSection-fileSection']")[0] != undefined){
                $("span[class$='fileSection-fileSection']")[0].textContent = 'Select a P12 file to upload'
            }
            if($("span[class$='fileSection-fileSection']")[1] != undefined){
                $("span[class$='fileSection-fileSection']").textContent = 'Select a P12 file to upload'
            }
    },[props.reset])
    var hash = window.location.hash;
    var currentJWTMerchantId = useSelector(state => state.configurationReducer.currentJWTMerchantId);
    useEffect(function switchState(){
        if(currentJWTMerchantId){
            props.setJWTMerchantId(currentJWTMerchantId);
        }
        else{
            props.setJWTMerchantId('');
            if(!(merchantID_def===' '||merchantID_def==='Organization ID')){
                resetTextField('Organization ID', setMerchantIDDefault,setMerchantIDTextStyle)
                resetTextField('Enter your password for the P12 file', setJWTKeyDefault,setJWTKeyTextStyle)
            }
        }
    },[currentJWTMerchantId])
    return (
     <div>
        <div class= "sandBoxDetailsCard">Sandbox Credentials</div>
        <p id={"default-creds-jwt-"+props.src.toLowerCase()} style={{display:'block'}}>You are using default sandbox account of {processor} processor. Upload P12 file here to change the account. Don't have certificate? &nbsp;
        <Link class="color_theme_link" href={getIsWidget() ? '#' : hash} onClick={()=> props.dialogStateSetter(true)}>
        Generate Certificate. 
        </Link>&nbsp;
        <Link class="color_theme_link" href={`/docs/${partnerName}/en-us/platform/developer/all/rest/rest-getting-started/restgs-jwt-message-intro/restgs-security-p12-intro.html`} target="_blank" rel="noopener"> Read our guide </Link>to learn more about the certificate. Required fields are denoted with an <mark class = "red">*</mark>.</p>
        <p id={"updated-creds-jwt-"+props.src.toLowerCase()} style={{display:'none'}}>You are using your own sandbox account. Use the Reset button to revert to default credentials.</p> 
        <div class = "jwtDiv">
            <div class = "jwtItems" style={{marginTop:'12px',display:'inline-flex'}}>
                <Textfield
                    i18n={{ label: 'Organization' }}
                    required={true}
                    width='300px'
                    value={(props.jwtMerchantId !== '')?props.jwtMerchantId:merchantID_def}
                    onFocus={() => handleFocus(setMerchantIDDefault, setMerchantIDTextStyle)}
                    onBlur={e => (e.target.value === '') ? resetTextField('Organization ID', setMerchantIDDefault, setMerchantIDTextStyle) : 1}
                    onChange={e => props.setJWTMerchantId(e.target.value)}
                    style={(props.jwtMerchantId !== '')?activeTextField:merchantID_textstyle}
                />
                <Textfield
                    className={"password"}
                    autoComplete="off"
                    i18n={{ label: 'Password', placeholder: 'Enter your password for the P12 file' }}
                    required={true}
                    width='300px'
                    type={type}
                    iconClass = {icon}
                    resolution="low"
                    value={props.jwtPass}
                    onChange={e => props.setJWTPass(e.target.value)}
                    style={(props.jwtPass !== '')?activePassField:jwtKey_textstyle}
                    dataTest="password-vdsTextField"
                    noValidate
                    onIconClick={() => {
                        if(type==='password'){
                            setType('text');
                            setIcon('password-hide');
                        }
                        else{
                            setType('password');
                            setIcon('password-show');
                        }
                    }}
                />
            </div>
            <div className="file-upload">
            <CybsFileUpload
                accept="*"
                dataTest="fileUploadSingle"
                onRetrieveFiles={retrieveFiles}
                i18n={{
                    title: '',
                    fileRequirements: 'All files accepted (< 1MB)',
                    noFilesSelected: 'Select a P12 file to upload',
                    browseBtnLabel: 'Browse',
                }}
                style={{marginTop: "0.25rem", maxWidth: "35rem"}}
            />
            </div>
        </div>
    </div>
    )
}

JWTSet.displayName = 'JWTSet';
export default JWTSet;